const container = {
  maxWidth: '1170px',
  padding: '0 15px',
} as const;

export default container;
